import { ChangeDetectionStrategy, Component, inject, linkedSignal, signal } from '@angular/core';
import { FormField, form, required } from '@angular/forms/signals';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { finalize } from 'rxjs';

import { Resource } from '../schemas';
import { Messenger, ResourcesService } from '../service';

export interface ResourceFormData {
  resource?: Resource;
  title?: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [
    FormField,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatDialogModule,
    MatProgressBarModule,
  ],
  template: `
    <h2 mat-dialog-title>{{ data.title ?? 'Create Resource' }}</h2>
    <mat-dialog-content>
      <div class="entity-form">
        <mat-form-field>
          <mat-label> Title </mat-label>
          <input [formField]="form.Title" matInput />
        </mat-form-field>

        <mat-form-field>
          <mat-label> URL </mat-label>
          <input [formField]="form.Url" matInput type="url" />
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button matMiniFab matTooltip="Save resource" (click)="save()" [disabled]="!form().valid() || pending()">
        <mat-icon>save</mat-icon>
      </button>
    </mat-dialog-actions>
    @if (pending()) {
      <mat-progress-bar mode="indeterminate" />
    }
  `,
})
export class ResourceForm {
  hostDialog = inject(MatDialogRef);
  resourceService = inject(ResourcesService);
  messenger = inject(Messenger);

  data = (inject(MAT_DIALOG_DATA) as ResourceFormData) || {};
  pending = signal(false);

  model = linkedSignal(() => ({
    Id: '',
    Title: '',
    Url: '',
    ...this.data.resource,
  }));

  form = form(this.model, (schema) => {
    required(schema.Title);
    required(schema.Url);
  });

  save() {
    this.pending.set(true);
    const data = this.form().value();

    this.resourceService
      .save(data, !!this.data.resource)
      .pipe(finalize(() => this.pending.set(false)))
      .subscribe({
        next: (data: Resource) => {
          this.hostDialog.close(data);
        },
        error: this.messenger.handleHttpError,
      });
  }
}
